const addSubcomponents = <Subcomponents extends { [key: string]: any }, Parent>(
  subs: Subcomponents,
  parent: Parent
) => {
  const assigned = parent as Parent & Partial<Subcomponents>

  Object.keys(subs).forEach(key => {
    assigned[key] = subs[key]
  })

  return assigned as Parent & Subcomponents
}

export default addSubcomponents
